import type { AccountNode } from '@taler/api-client'
import { type Locale, resolveLocalized } from '@taler/domain'

export interface ExpenseAccountOption {
  readonly id: string
  readonly label: string
}

/** Every postable expense leaf, the same target a recognition entry can post against. */
export function expenseAccountOptions(
  nodes: readonly AccountNode[],
  locale: Locale,
): readonly ExpenseAccountOption[] {
  const out: ExpenseAccountOption[] = []
  const walk = (node: AccountNode): void => {
    const { account } = node
    if (account.isPostable && account.accountClass === 'EXPENSE' && account.archivedAt === undefined) {
      out.push({ id: account.id, label: resolveLocalized(account.names, locale)?.name ?? account.code })
    }
    for (const child of node.children) walk(child)
  }
  for (const node of nodes) walk(node)
  return out
}
